webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(13);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _routers = __webpack_require__(9);
	
	var _routers2 = _interopRequireDefault(_routers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  router: _routers2.default,
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	}); // The Vue build version to load with the `import` command
	// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: 'app'
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(7);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _markdown = __webpack_require__(6);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	
	var regex = /^\s*(\-|\*|\>)(\s*)([\S]+)/g;
	// import parser from 'gpkparser'
	exports.default = {
	  name: 'gpk-editor',
	  data: function data() {
	    return {
	      input: _markdown2.default,
	      info: {
	        line: 0,
	        index: 0
	      }
	    };
	  },
	
	  computed: {
	    compiledMarkdown: function compiledMarkdown() {
	      return (0, _index2.default)(this.input);
	    }
	  },
	  methods: {
	    update: function update(e) {
	      var _this = this;
	
	      this.info = getLineNumberAndColumnIndex(e.target);
	      setTimeout(function () {
	        _this.input = e.target.value;
	      });
	      console.log(e);
	      if (e.keyCode === 13) {
	        this.enter(e);
	      }
	    },
	    enter: function enter(e) {
	      var array = e.target.value.split('\n');
	      var top = array[this.info.line - 2];
	      var result = regex.exec(top);
	      if (result === null) {
	        return;
	      }
	      console.log(result);
	      var i = result[0].indexOf(result[1]);
	      var begin = result[0].substr(0, i + 1) + ' ';
	      setTimeout(function () {
	        insertAtCursor(e.target, begin);
	      }, 300);
	    }
	  }
	};
	
	
	function getLineNumberAndColumnIndex(textarea) {
	  var textLines = textarea.value.substr(0, textarea.selectionStart).split("\n");
	  var currentLineNumber = textLines.length;
	  var currentColumnIndex = textLines[textLines.length - 1].length;
	  console.log("Current Line Number " + currentLineNumber + " Current Column Index " + currentColumnIndex);
	  return {
	    line: currentLineNumber,
	    index: currentColumnIndex
	  };
	}
	
	function insertAtCursor(myField, myValue) {
	  if (document.selection) {
	    //IE support
	
	    myField.focus();
	    sel = document.selection.createRange();
	    sel.text = myValue;
	    sel.select();
	  } else if (myField.selectionStart || myField.selectionStart == '0') {
	    //MOZILLA/NETSCAPE support
	    var startPos = myField.selectionStart;
	    var endPos = myField.selectionEnd;
	    var beforeValue = myField.value.substring(0, startPos);
	    var afterValue = myField.value.substring(endPos, myField.value.length);
	
	    myField.value = beforeValue + myValue + afterValue;
	
	    myField.selectionStart = startPos + myValue.length;
	    myField.selectionEnd = startPos + myValue.length;
	    myField.focus();
	  } else {
	    myField.value += myValue;
	    myField.focus();
	  }
	}
	
	function getCursortPosition(ctrl) {
	  //获取光标位置函数
	  var CaretPos = 0; // IE Support
	  if (document.selection) {
	    ctrl.focus();
	    var Sel = document.selection.createRange();
	    Sel.moveStart('character', -ctrl.value.length);
	    CaretPos = Sel.text.length;
	  }
	  // Firefox support
	  else if (ctrl.selectionStart || ctrl.selectionStart == '0') CaretPos = ctrl.selectionStart;
	  return CaretPos;
	}
	
	function setCaretPosition(ctrl, pos) {
	  //设置光标位置函数
	  if (ctrl.setSelectionRange) {
	    ctrl.focus();
	    ctrl.setSelectionRange(pos, pos);
	  } else if (ctrl.createTextRange) {
	    var range = ctrl.createTextRange();
	    range.collapse(true);
	    range.moveEnd('character', pos);
	    range.moveStart('character', pos);
	    range.select();
	  }
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GPKEditor = __webpack_require__(14);
	
	var _GPKEditor2 = _interopRequireDefault(_GPKEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'index-view',
	  components: {
	    'gpk-editor': _GPKEditor2.default
	  }
	}; //
	//
	//
	//
	//

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = "# Dillinger\n\n[![N|Solid](https://cldup.com/dTxpPi9lDf.thumb.png)](https://nodesource.com/products/nsolid)\n\nDillinger is a cloud-enabled, mobile-ready, offline-storage, AngularJS powered HTML5 Markdown editor.\n\n  - Type some Markdown on the left\n  - See HTML in the right\n  - Magic\n\n# New Features!\n\n  - Import a HTML file and watch it magically convert to Markdown\n  - Drag and drop images (requires your Dropbox account be linked)\n\n\nYou can also:\n\n  - Import and save files from GitHub, Dropbox, Google Drive and One Drive\n  - Drag and drop markdown and HTML files into Dillinger\n  - Export documents as Markdown, HTML and PDF\n\nMarkdown is a lightweight markup language based on the formatting conventions that people naturally use in email.  As [John Gruber] writes on the [Markdown site][df1]\n\n> The overriding design goal for Markdown's\n> formatting syntax is to make it as readable\n> as possible. The idea is that a\n> Markdown-formatted document should be\n> publishable as-is, as plain text, without\n> looking like it's been marked up with tags\n> or formatting instructions.\n\nThis text you see here is *actually* written in Markdown! To get a feel for Markdown's syntax, type some text into the left window and watch the results in the right.\n\n### Tech\n\nDillinger uses a number of open source projects to work properly:\n\n* [AngularJS] - HTML enhanced for web apps!\n* [Ace Editor] - awesome web-based text editor\n* [markdown-it] - Markdown parser done right. Fast and easy to extend.\n* [Twitter Bootstrap] - great UI boilerplate for modern web apps\n* [node.js] - evented I/O for the backend\n* [Express] - fast node.js network app framework [@tjholowaychuk]\n* [Gulp] - the streaming build system\n* [Breakdance](http://breakdance.io) - HTML to Markdown converter\n* [jQuery] - duh\n\nAnd of course Dillinger itself is open source with a [public repository][dill]\n on GitHub.\n\n### Installation\n\nDillinger requires [Node.js](https://nodejs.org/) v4+ to run.\n\nInstall the dependencies and devDependencies and start the server.\n\n```sh\n$ cd dillinger\n$ npm install -d\n$ node app\n```\n\nFor production environments...\n\n```sh\n$ npm install --production\n$ npm run predeploy\n$ NODE_ENV=production node app\n```\n\n### Plugins\n\nDillinger is currently extended with the following plugins. Instructions on how to use them in your own application are linked below.\n\n| Plugin | README | haha |\n| ------ | ------ | ------ |\n| Dropbox | [plugins/dropbox/README.md] [PlDb] | test |\n| Github | [plugins/github/README.md] [PlGh] | test |\n| Google Drive | [plugins/googledrive/README.md] [PlGd] | test |\n| OneDrive | [plugins/onedrive/README.md] [PlOd] | test |\n| Medium | [plugins/medium/README.md] [PlMe] | test |\n| Google Analytics | [plugins/googleanalytics/README.md] [PlGa] | test |\n\n\n### Development\n\nWant to contribute? Great!\n\nDillinger uses Gulp + Webpack for fast developing.\nMake a change in your file and instantanously see your updates!\n\nOpen your favorite Terminal and run these commands.\n\nFirst Tab:\n\n```sh\n$ node app\n```\n\nSecond Tab:\n\n```sh\n$ gulp watch\n```\n\n(optional) Third:\n\n```sh\n$ karma test\n```\n#### Building for source\nFor production release:\n```sh\n$ gulp build --prod\n```\nGenerating pre-built zip archives for distribution:\n```sh\n$ gulp build dist --prod\n```\n### Docker\nDillinger is very easy to install and deploy in a Docker container.\n\nBy default, the Docker will expose port 80, so change this within the Dockerfile if necessary. When ready, simply use the Dockerfile to build the image.\n\n```sh\ncd dillinger\ndocker build -t joemccann/dillinger:\n```\nThis will create the dillinger image and pull in the necessary dependencies. Be sure to swap out `json.version` with the actual version of Dillinger.\n\nOnce done, run the Docker image and map the port to whatever you wish on your host. In this example, we simply map port 8000 of the host to port 80 of the Docker (or whatever port was exposed in the Dockerfile):\n\n```sh\ndocker run -d -p 8000:8080 --restart=\"always\" <youruser>/dillinger:\n```\n\nVerify the deployment by navigating to your server address in your preferred browser.\n\n```sh\n127.0.0.1:8000\n```\n\n#### Kubernetes + Google Cloud\n\nSee [KUBERNETES.md](https://github.com/joemccann/dillinger/blob/master/KUBERNETES.md)\n\n\n### Todos\n\n - Write MOAR Tests\n - Add Night Mode\n\nLicense\n\n----\n\nMIT\n\n\n**Free Software, Hell Yeah!**\n\n[//]: # (These are reference links used in the body of this note and get stripped out when the markdown processor does its job. There is no need to format nicely because it shouldn't be seen. Thanks SO - http://stackoverflow.com/questions/4823468/store-comments-in-markdown-syntax)\n\n\n   [dill]: <https://github.com/joemccann/dillinger>\n   [git-repo-url]: <https://github.com/joemccann/dillinger.git>\n   [john gruber]: <http://daringfireball.net>\n   [df1]: <http://daringfireball.net/projects/markdown/>\n   [markdown-it]: <https://github.com/markdown-it/markdown-it>\n   [Ace Editor]: <http://ace.ajax.org>\n   [node.js]: <http://nodejs.org>\n   [Twitter Bootstrap]: <http://twitter.github.com/bootstrap/>\n   [jQuery]: <http://jquery.com>\n   [@tjholowaychuk]: <http://twitter.com/tjholowaychuk>\n   [express]: <http://expressjs.com>\n   [AngularJS]: <http://angularjs.org>\n   [Gulp]: <http://gulpjs.com>\n\n   [PlDb]: <https://github.com/joemccann/dillinger/tree/master/plugins/dropbox/README.md>\n   [PlGh]: <https://github.com/joemccann/dillinger/tree/master/plugins/github/README.md>\n   [PlGd]: <https://github.com/joemccann/dillinger/tree/master/plugins/googledrive/README.md>\n   [PlOd]: <https://github.com/joemccann/dillinger/tree/master/plugins/onedrive/README.md>\n   [PlMe]: <https://github.com/joemccann/dillinger/tree/master/plugins/medium/README.md>\n   [PlGa]: <https://github.com/RahulHP/dillinger/blob/master/plugins/googleanalytics/README.md>\n";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function parseDom(el) {
	  var h_reg = /h\d+/;
	  var dom = '';
	  var currentLinks = this;
	  switch (el.type) {
	    case undefined:
	      {
	        break;
	      }
	    case 'p':
	      {
	
	        dom = '<p>' + findChildrens(el, currentLinks) + '</p>' + '\n';
	        break;
	      }
	    case 'strong':
	      {
	        var rows = el.content[0].map(function (sub) {
	          return sub[0];
	        }).join('');
	        dom = '<strong>' + rows + '</strong>' + '\n';
	        break;
	      }
	    case 'em':
	      {
	        dom = '<em>' + el.content.split(',').join('') + '</em>' + '\n';
	        break;
	      }
	    case 'code':
	      {
	        var _rows = el.content[0].map(function (el) {
	          return '' + el.content;
	        });
	        dom = '<pre><code language=' + el.language + '>' + _rows + '</code></pre>';
	        break;
	      }
	    case 'table':
	      {
	        var mapTable = function mapTable(sub, currentLinks) {
	          var result = '';
	          sub.forEach(function (subEl) {
	            if ((typeof subEl === 'undefined' ? 'undefined' : _typeof(subEl)) === 'object') {
	              result += '<td>' + parseDom.call(currentLinks, subEl) + '</td>';
	            } else {
	              result += '<td>' + subEl + '</td>';
	            }
	          });
	          return result;
	        };
	        var th = el.th.map(function (el) {
	          return '<th>' + el + '</th>';
	        }).join('');
	        var head = '<thead><tr>' + th + '</tr></thead>';
	        var tb = el.content[0].map(function (sub) {
	          return '<tr>' + mapTable(sub, currentLinks) + '</tr>';
	        }).join('');
	        var body = '<tbody>' + tb + '</tbody>';
	        dom = '<table>' + head + body + '</table>';
	        break;
	      }
	    case 'a':
	      {
	        dom = '<a href=' + el.url + '>' + el.content + '</a>';
	        break;
	      }
	    case 'img':
	      {
	        dom = '<img src="' + el.url + '" alt=' + el.content + '>';
	        break;
	      }
	    case 'a_img':
	      {
	        dom = '<a href=' + el.url + '>\n              <img src="' + el.img.url + '" alt=' + el.img.content + '>\n              </a>';
	        break;
	      }
	    case 'quote_list':
	      {
	        dom = '<blockquote><p>' + el.content[0][0].map(function (el) {
	          return el + '</br>';
	        }).join('') + '</p></blockquote>';
	        break;
	      }
	    case 'ul':
	      {
	        var lis = el.content[0].map(function (sub) {
	          return '<li>' + mapList(sub, currentLinks) + '</li>';
	        }).join('');
	        dom = '<ul>' + lis + '</ul>';
	        break;
	      }
	    case 'hr':
	      {
	        dom = '<hr>';
	        break;
	      }
	    case 'inline_code':
	      {
	        dom = '<code>' + el.content.split(',').join('') + '</code>';
	        break;
	      }
	    case h_reg.exec(el.type) && h_reg.exec(el.type).input:
	      {
	        dom = '<' + el.type + '>' + el.content + '</' + el.type + '>';
	        break;
	      }
	    case 'anchor_with_name':
	      {
	        var anchor = findLink(currentLinks, el.name);
	        if (anchor) {
	          dom = '<a href=' + anchor.url + '>' + el.content + '</a>';
	        }
	        break;
	      }
	    case 'anchor':
	      {
	        var _anchor = findLink(currentLinks, el.content);
	        if (_anchor) {
	          dom = '<a href=' + _anchor.url + '>' + _anchor.content + '</a>';
	        }
	        break;
	      }
	    default:
	      {
	        // console.log(el);
	      }
	  }
	  return dom;
	}
	
	var mapList = function mapList(sub, currentLinks) {
	  var result = '';
	  sub.forEach(function (subEl) {
	    if ((typeof subEl === 'undefined' ? 'undefined' : _typeof(subEl)) === 'object') {
	      result += parseDom.call(currentLinks, subEl);
	    } else {
	      result += subEl;
	    }
	  });
	  return result;
	};
	
	function findChildrens(el, currentLinks) {
	  var result = '';
	  el.content.forEach(function (sub) {
	    result += mapList(sub, currentLinks);
	  });
	  return result;
	}
	
	function findLink(links, name) {
	  var result = null;
	  links.forEach(function (el) {
	    if (el.content.toLowerCase() === name.toLowerCase()) {
	      result = el;
	      return false;
	    }
	  });
	  return result;
	}
	
	function mapAll(el, callback) {
	  if (el === '' || el === null || el === undefined) {
	    return;
	  }
	  var buffer = callback(el);
	  if ((typeof el === 'undefined' ? 'undefined' : _typeof(el)) === 'object' && el.length > 0) {
	    el.forEach(function (sub) {
	      mapAll(sub, callback);
	    });
	  }
	}
	
	module.exports = function (input) {
	  var p = __webpack_require__(8);
	  var markdown = p.parse(input);
	  var links = [];
	  var dom = '';
	  var getLinks = function getLinks(el) {
	    if (el.type === 'global_link_list') {
	      links = el.content[0];
	    }
	  };
	  var getDom = function getDom(el) {
	    dom += parseDom.call(links, el);
	  };
	  mapAll(markdown, getLinks);
	  mapAll(markdown, getDom);
	  return dom;
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = /*
	                 * Generated by PEG.js 0.10.0.
	                 *
	                 * http://pegjs.org/
	                 */
	function () {
	  "use strict";
	
	  function peg$subclass(child, parent) {
	    function ctor() {
	      this.constructor = child;
	    }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message = message;
	    this.expected = expected;
	    this.found = found;
	    this.location = location;
	    this.name = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  peg$SyntaxError.buildMessage = function (expected, found) {
	    var DESCRIBE_EXPECTATION_FNS = {
	      literal: function literal(expectation) {
	        return "\"" + literalEscape(expectation.text) + "\"";
	      },
	
	      "class": function _class(expectation) {
	        var escapedParts = "",
	            i;
	
	        for (i = 0; i < expectation.parts.length; i++) {
	          escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
	        }
	
	        return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
	      },
	
	      any: function any(expectation) {
	        return "any character";
	      },
	
	      end: function end(expectation) {
	        return "end of input";
	      },
	
	      other: function other(expectation) {
	        return expectation.description;
	      }
	    };
	
	    function hex(ch) {
	      return ch.charCodeAt(0).toString(16).toUpperCase();
	    }
	
	    function literalEscape(s) {
	      return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
	        return '\\x0' + hex(ch);
	      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
	        return '\\x' + hex(ch);
	      });
	    }
	
	    function classEscape(s) {
	      return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
	        return '\\x0' + hex(ch);
	      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
	        return '\\x' + hex(ch);
	      });
	    }
	
	    function describeExpectation(expectation) {
	      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
	    }
	
	    function describeExpected(expected) {
	      var descriptions = new Array(expected.length),
	          i,
	          j;
	
	      for (i = 0; i < expected.length; i++) {
	        descriptions[i] = describeExpectation(expected[i]);
	      }
	
	      descriptions.sort();
	
	      if (descriptions.length > 0) {
	        for (i = 1, j = 1; i < descriptions.length; i++) {
	          if (descriptions[i - 1] !== descriptions[i]) {
	            descriptions[j] = descriptions[i];
	            j++;
	          }
	        }
	        descriptions.length = j;
	      }
	
	      switch (descriptions.length) {
	        case 1:
	          return descriptions[0];
	
	        case 2:
	          return descriptions[0] + " or " + descriptions[1];
	
	        default:
	          return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
	      }
	    }
	
	    function describeFound(found) {
	      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
	    }
	
	    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
	  };
	
	  function peg$parse(input, options) {
	    options = options !== void 0 ? options : {};
	
	    var peg$FAILED = {},
	        peg$startRuleFunctions = { markdown: peg$parsemarkdown },
	        peg$startRuleFunction = peg$parsemarkdown,
	        peg$c0 = function peg$c0(ps) {
	      var is_array = function is_array(el) {
	        return (typeof el === "undefined" ? "undefined" : _typeof(el)) === 'object' && el.length > 0;
	      };
	      var is_object = function is_object(el) {
	        return (typeof el === "undefined" ? "undefined" : _typeof(el)) === 'object';
	      };
	      var mapAll = function mapAll(element) {
	        if (element === undefined) {
	          return;
	        }
	        if (is_array(element)) {
	          element.forEach(function (el, index) {
	            if (el === undefined) {
	              element.splice(index, 1);
	            } else {
	              mapAll(el);
	            }
	          });
	        } else if (is_object(element)) {
	          mapAll(element.content);
	        }
	      };
	
	      var groupBy = function groupBy(fn, source) {
	        var result = [];
	        var current = 0;
	        if (source === undefined || (typeof source === "undefined" ? "undefined" : _typeof(source)) !== 'object' || source.length === undefined) {
	          return;
	        }
	        source.forEach(function (el, index) {
	          if (!fn(el, source[index + 1])) {
	            result.push(source.slice(current, index + 1));
	            current = index + 1;
	          }
	        });
	        return result;
	      };
	
	      var fn = function fn(x, y) {
	        return (typeof x === "undefined" ? "undefined" : _typeof(x)) === (typeof y === "undefined" ? "undefined" : _typeof(y));
	      };
	      ps.forEach(function (x) {
	        x.content = groupBy(fn, x.content);
	        if (x.content) {
	          x.content = x.content.map(function (el) {
	            if (_typeof(el[0]) === 'object') {
	              return el.map(function (sub) {
	                if (_typeof(sub.content) === 'object') {
	                  sub.content = sub.content.join('');
	                }
	                return sub;
	              });
	            }
	            return [el.join('')];
	          });
	          x.content = [].concat.apply(x.content);
	          mapAll(x.content);
	        }
	      });
	      return ps;
	    },
	        peg$c1 = function peg$c1(p) {
	
	      return p[1];
	    },
	        peg$c2 = function peg$c2(q) {
	      return { type: 'quote', content: q };
	    },
	        peg$c3 = function peg$c3(x) {
	      return { type: 'p', content: x };
	    },
	        peg$c4 = "#",
	        peg$c5 = peg$literalExpectation("#", false),
	        peg$c6 = " ",
	        peg$c7 = peg$literalExpectation(" ", false),
	        peg$c8 = function peg$c8(h, t) {
	      return { type: 'h' + h.length, content: t };
	    },
	        peg$c9 = "> ",
	        peg$c10 = peg$literalExpectation("> ", false),
	        peg$c11 = function peg$c11(t) {
	      return t;
	    },
	        peg$c12 = function peg$c12(q, list) {
	      var newList = [q].concat(list.map(function (a) {
	        return a[1];
	      })).map(function (el) {
	        return el.join("");
	      });
	      return { type: 'quote_list', content: [newList] };
	    },
	        peg$c13 = function peg$c13(tb) {
	      return { type: 'table', th: tb[0], content: tb.splice(2, tb.length) };
	    },
	        peg$c14 = "|",
	        peg$c15 = peg$literalExpectation("|", false),
	        peg$c16 = "\n",
	        peg$c17 = peg$literalExpectation("\n", false),
	        peg$c18 = function peg$c18(x) {
	      return x;
	    },
	        peg$c19 = function peg$c19(t) {
	      return t[1];
	    },
	        peg$c20 = /^[^|]/,
	        peg$c21 = peg$classExpectation(["|"], true, false),
	        peg$c22 = function peg$c22(x) {
	      return x.join('');
	    },
	        peg$c23 = "- ",
	        peg$c24 = peg$literalExpectation("- ", false),
	        peg$c25 = "* ",
	        peg$c26 = peg$literalExpectation("* ", false),
	        peg$c27 = function peg$c27(t) {
	      return { type: 'li', li: t };
	    },
	        peg$c28 = function peg$c28(xs) {
	      var rows = xs.map(function (el) {
	        return el[1].li;
	      });
	      return { type: 'ul', content: rows };
	    },
	        peg$c29 = "![",
	        peg$c30 = peg$literalExpectation("![", false),
	        peg$c31 = "](",
	        peg$c32 = peg$literalExpectation("](", false),
	        peg$c33 = ")",
	        peg$c34 = peg$literalExpectation(")", false),
	        peg$c35 = function peg$c35(t, url) {
	      return { type: 'img', url: url, content: t };
	    },
	        peg$c36 = "[",
	        peg$c37 = peg$literalExpectation("[", false),
	        peg$c38 = function peg$c38(t, url) {
	      return { type: 'a', url: url, content: t };
	    },
	        peg$c39 = function peg$c39(i, url) {
	      return { type: 'a_img', url: url, img: i };
	    },
	        peg$c40 = /^[a-zA-Z0-9|:\/.!]/,
	        peg$c41 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "|", ":", "/", ".", "!"], false, false),
	        peg$c42 = "[//]:",
	        peg$c43 = peg$literalExpectation("[//]:", false),
	        peg$c44 = function peg$c44(t) {
	      return { type: 'annotation', content: t };
	    },
	        peg$c45 = "-",
	        peg$c46 = peg$literalExpectation("-", false),
	        peg$c47 = function peg$c47() {
	      return { type: 'hr', content: "" };
	    },
	        peg$c48 = "```",
	        peg$c49 = peg$literalExpectation("```", false),
	        peg$c50 = function peg$c50(l, c) {
	      return { type: 'code', content: [c], language: l };
	    },
	        peg$c51 = function peg$c51(rows) {
	      return { type: 'code_rows', content: rows };
	    },
	        peg$c52 = /^[^`\n]/,
	        peg$c53 = peg$classExpectation(["`", "\n"], true, false),
	        peg$c54 = function peg$c54(lns) {
	      return lns[0][0];
	    },
	        peg$c55 = /^[^\n]/,
	        peg$c56 = peg$classExpectation(["\n"], true, false),
	        peg$c57 = "**",
	        peg$c58 = peg$literalExpectation("**", false),
	        peg$c59 = function peg$c59(t) {
	      return { type: 'strong', content: t };
	    },
	        peg$c60 = "*",
	        peg$c61 = peg$literalExpectation("*", false),
	        peg$c62 = function peg$c62(t) {
	      return { type: 'em', content: [t] };
	    },
	        peg$c63 = "`",
	        peg$c64 = peg$literalExpectation("`", false),
	        peg$c65 = function peg$c65(t) {
	      return { type: 'inline_code', content: t };
	    },
	        peg$c66 = "]",
	        peg$c67 = peg$literalExpectation("]", false),
	        peg$c68 = "][",
	        peg$c69 = peg$literalExpectation("][", false),
	        peg$c70 = function peg$c70(t, name) {
	      return { type: "anchor_with_name", content: t.split(",").join(""), name: name.split(",").join("") };
	    },
	        peg$c71 = function peg$c71(t) {
	
	      return { type: "anchor", content: t.split(",").join("") };
	    },
	        peg$c72 = /^[a-zA-Z0-9|:\/.!\-]/,
	        peg$c73 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "|", ":", "/", ".", "!", "-"], false, false),
	        peg$c74 = "]: <",
	        peg$c75 = peg$literalExpectation("]: <", false),
	        peg$c76 = ">",
	        peg$c77 = peg$literalExpectation(">", false),
	        peg$c78 = function peg$c78(t, url) {
	      return { type: 'global_link', content: [t.split(',').join('')], url: url };
	    },
	        peg$c79 = function peg$c79(ts) {
	      return { type: 'global_link_list', content: ts.map(function (el) {
	          return el[1];
	        }) };
	    },
	        peg$c80 = peg$otherExpectation("whitespace"),
	        peg$c81 = /^[ \t\n\r]/,
	        peg$c82 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false),
	        peg$c83 = /^[ \t\r]/,
	        peg$c84 = peg$classExpectation([" ", "\t", "\r"], false, false),
	        peg$currPos = 0,
	        peg$savedPos = 0,
	        peg$posDetailsCache = [{ line: 1, column: 1 }],
	        peg$maxFailPos = 0,
	        peg$maxFailExpected = [],
	        peg$silentFails = 0,
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description, location) {
	      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
	
	      throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
	    }
	
	    function error(message, location) {
	      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
	
	      throw peg$buildSimpleError(message, location);
	    }
	
	    function peg$literalExpectation(text, ignoreCase) {
	      return { type: "literal", text: text, ignoreCase: ignoreCase };
	    }
	
	    function peg$classExpectation(parts, inverted, ignoreCase) {
	      return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
	    }
	
	    function peg$anyExpectation() {
	      return { type: "any" };
	    }
	
	    function peg$endExpectation() {
	      return { type: "end" };
	    }
	
	    function peg$otherExpectation(description) {
	      return { type: "other", description: description };
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line: details.line,
	          column: details.column
	        };
	
	        while (p < pos) {
	          if (input.charCodeAt(p) === 10) {
	            details.line++;
	            details.column = 1;
	          } else {
	            details.column++;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line: startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line: endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) {
	        return;
	      }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildSimpleError(message, location) {
	      return new peg$SyntaxError(message, null, null, location);
	    }
	
	    function peg$buildStructuredError(expected, found, location) {
	      return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
	    }
	
	    function peg$parsemarkdown() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parseparagraph();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parseparagraph();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseparagraph() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      s2 = peg$parse_();
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parseparagraph_content();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parse_();
	          if (s4 !== peg$FAILED) {
	            s2 = [s2, s3, s4];
	            s1 = s2;
	          } else {
	            peg$currPos = s1;
	            s1 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseparagraph_content() {
	      var s0, s1;
	
	      s0 = peg$parseheading();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseglobal_link_list();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parsequote_list();
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            s1 = peg$parsequote();
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c2(s1);
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$parsecode();
	              if (s0 === peg$FAILED) {
	                s0 = peg$parseul_list();
	                if (s0 === peg$FAILED) {
	                  s0 = peg$parseul_li();
	                  if (s0 === peg$FAILED) {
	                    s0 = peg$parsetable();
	                    if (s0 === peg$FAILED) {
	                      s0 = peg$parsea_img();
	                      if (s0 === peg$FAILED) {
	                        s0 = peg$parsea();
	                        if (s0 === peg$FAILED) {
	                          s0 = peg$parseimg();
	                          if (s0 === peg$FAILED) {
	                            s0 = peg$parseline();
	                            if (s0 === peg$FAILED) {
	                              s0 = peg$parsestrong();
	                              if (s0 === peg$FAILED) {
	                                s0 = peg$parseannotation();
	                                if (s0 === peg$FAILED) {
	                                  s0 = peg$currPos;
	                                  s1 = peg$parseplain_text_paragraph();
	                                  if (s1 !== peg$FAILED) {
	                                    peg$savedPos = s0;
	                                    s1 = peg$c3(s1);
	                                  }
	                                  s0 = s1;
	                                }
	                              }
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseheading() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = [];
	      if (input.charCodeAt(peg$currPos) === 35) {
	        s2 = peg$c4;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c5);
	        }
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          if (input.charCodeAt(peg$currPos) === 35) {
	            s2 = peg$c4;
	            peg$currPos++;
	          } else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c5);
	            }
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        if (input.charCodeAt(peg$currPos) === 32) {
	          s2 = peg$c6;
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c7);
	          }
	        }
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsetext();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c8(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsequote() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        if (input.substr(peg$currPos, 2) === peg$c9) {
	          s2 = peg$c9;
	          peg$currPos += 2;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c10);
	          }
	        }
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsetext();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c11(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsequote_list() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = peg$parsequote();
	      if (s1 !== peg$FAILED) {
	        s2 = [];
	        s3 = peg$currPos;
	        s4 = peg$parse_();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parsequote();
	          if (s5 !== peg$FAILED) {
	            s4 = [s4, s5];
	            s3 = s4;
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s3;
	          s3 = peg$FAILED;
	        }
	        if (s3 !== peg$FAILED) {
	          while (s3 !== peg$FAILED) {
	            s2.push(s3);
	            s3 = peg$currPos;
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsequote();
	              if (s5 !== peg$FAILED) {
	                s4 = [s4, s5];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          }
	        } else {
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c12(s1, s2);
	          s0 = s1;
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsetable() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = [];
	        s3 = peg$parsetable_tr();
	        if (s3 !== peg$FAILED) {
	          while (s3 !== peg$FAILED) {
	            s2.push(s3);
	            s3 = peg$parsetable_tr();
	          }
	        } else {
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c13(s2);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsetable_tr() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 124) {
	        s1 = peg$c14;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c15);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = [];
	        s3 = peg$parsetable_item();
	        if (s3 !== peg$FAILED) {
	          while (s3 !== peg$FAILED) {
	            s2.push(s3);
	            s3 = peg$parsetable_item();
	          }
	        } else {
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 10) {
	            s3 = peg$c16;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c17);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s2);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsetable_item() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      s2 = peg$parse_();
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsetable_text_formated();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parse_();
	          if (s4 !== peg$FAILED) {
	            s2 = [s2, s3, s4];
	            s1 = s2;
	          } else {
	            peg$currPos = s1;
	            s1 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        if (input.charCodeAt(peg$currPos) === 124) {
	          s2 = peg$c14;
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c15);
	          }
	        }
	        if (s2 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c19(s1);
	          s0 = s1;
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsetable_text_formated() {
	      var s0;
	
	      s0 = peg$parseformated_text();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsetable_text();
	      }
	
	      return s0;
	    }
	
	    function peg$parsetable_text() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      if (peg$c20.test(input.charAt(peg$currPos))) {
	        s2 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c21);
	        }
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          if (peg$c20.test(input.charAt(peg$currPos))) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c21);
	            }
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c22(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseul_li_item() {
	      var s0;
	
	      if (input.substr(peg$currPos, 2) === peg$c23) {
	        s0 = peg$c23;
	        peg$currPos += 2;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c24);
	        }
	      }
	      if (s0 === peg$FAILED) {
	        if (input.substr(peg$currPos, 2) === peg$c25) {
	          s0 = peg$c25;
	          peg$currPos += 2;
	        } else {
	          s0 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c26);
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseul_li() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = peg$parseul_li_item();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parsetext();
	        if (s2 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c27(s2);
	          s0 = s1;
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseul_list() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parseul_li();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parseul_li();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c28(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseimg() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 2) === peg$c29) {
	        s1 = peg$c29;
	        peg$currPos += 2;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c30);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parsea_img_text();
	        if (s2 !== peg$FAILED) {
	          if (input.substr(peg$currPos, 2) === peg$c31) {
	            s3 = peg$c31;
	            peg$currPos += 2;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c32);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsea_img_text();
	            if (s4 !== peg$FAILED) {
	              if (input.charCodeAt(peg$currPos) === 41) {
	                s5 = peg$c33;
	                peg$currPos++;
	              } else {
	                s5 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                  peg$fail(peg$c34);
	                }
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c35(s2, s4);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsea() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 91) {
	        s1 = peg$c36;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c37);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parsea_img_text();
	        if (s2 !== peg$FAILED) {
	          if (input.substr(peg$currPos, 2) === peg$c31) {
	            s3 = peg$c31;
	            peg$currPos += 2;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c32);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsea_img_text();
	            if (s4 !== peg$FAILED) {
	              if (input.charCodeAt(peg$currPos) === 41) {
	                s5 = peg$c33;
	                peg$currPos++;
	              } else {
	                s5 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                  peg$fail(peg$c34);
	                }
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c38(s2, s4);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsea_img() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 91) {
	        s1 = peg$c36;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c37);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseimg();
	        if (s2 !== peg$FAILED) {
	          if (input.substr(peg$currPos, 2) === peg$c31) {
	            s3 = peg$c31;
	            peg$currPos += 2;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c32);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsea_img_text();
	            if (s4 !== peg$FAILED) {
	              if (input.charCodeAt(peg$currPos) === 41) {
	                s5 = peg$c33;
	                peg$currPos++;
	              } else {
	                s5 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                  peg$fail(peg$c34);
	                }
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c39(s2, s4);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsea_img_text() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      if (peg$c40.test(input.charAt(peg$currPos))) {
	        s2 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c41);
	        }
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          if (peg$c40.test(input.charAt(peg$currPos))) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c41);
	            }
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c22(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseannotation() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        if (input.substr(peg$currPos, 5) === peg$c42) {
	          s2 = peg$c42;
	          peg$currPos += 5;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c43);
	          }
	        }
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsetext();
	            if (s4 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c44(s4);
	              s0 = s1;
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseline() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = [];
	        if (input.charCodeAt(peg$currPos) === 45) {
	          s3 = peg$c45;
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c46);
	          }
	        }
	        if (s3 !== peg$FAILED) {
	          while (s3 !== peg$FAILED) {
	            s2.push(s3);
	            if (input.charCodeAt(peg$currPos) === 45) {
	              s3 = peg$c45;
	              peg$currPos++;
	            } else {
	              s3 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c46);
	              }
	            }
	          }
	        } else {
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c47();
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsecode() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 3) === peg$c48) {
	        s1 = peg$c48;
	        peg$currPos += 3;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c49);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parsetext();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 10) {
	            s3 = peg$c16;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c17);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsecode_rows();
	            if (s4 !== peg$FAILED) {
	              if (input.substr(peg$currPos, 3) === peg$c48) {
	                s5 = peg$c48;
	                peg$currPos += 3;
	              } else {
	                s5 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                  peg$fail(peg$c49);
	                }
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c50(s2, s4);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsecode_rows() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parsecode_rows_text();
	      if (s3 !== peg$FAILED) {
	        if (input.charCodeAt(peg$currPos) === 10) {
	          s4 = peg$c16;
	          peg$currPos++;
	        } else {
	          s4 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c17);
	          }
	        }
	        if (s4 !== peg$FAILED) {
	          s3 = [s3, s4];
	          s2 = s3;
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parsecode_rows_text();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 10) {
	              s4 = peg$c16;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c17);
	              }
	            }
	            if (s4 !== peg$FAILED) {
	              s3 = [s3, s4];
	              s2 = s3;
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c51(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsecode_rows_text() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      if (peg$c52.test(input.charAt(peg$currPos))) {
	        s2 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c53);
	        }
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          if (peg$c52.test(input.charAt(peg$currPos))) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c53);
	            }
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c22(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseplain_text_paragraph() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parsetext();
	      if (s3 !== peg$FAILED) {
	        if (input.charCodeAt(peg$currPos) === 10) {
	          s4 = peg$c16;
	          peg$currPos++;
	        } else {
	          s4 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c17);
	          }
	        }
	        if (s4 === peg$FAILED) {
	          s4 = null;
	        }
	        if (s4 !== peg$FAILED) {
	          s3 = [s3, s4];
	          s2 = s3;
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parsetext();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 10) {
	              s4 = peg$c16;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c17);
	              }
	            }
	            if (s4 === peg$FAILED) {
	              s4 = null;
	            }
	            if (s4 !== peg$FAILED) {
	              s3 = [s3, s4];
	              s2 = s3;
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c54(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsetext_single() {
	      var s0;
	
	      s0 = peg$parseformated_text();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsenormal_text();
	      }
	
	      return s0;
	    }
	
	    function peg$parsetext() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsetext_single();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsetext_single();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c18(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsenormal_text() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      if (peg$c55.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c56);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c18(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseformated_text() {
	      var s0;
	
	      s0 = peg$parsea();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseanchor_with_name();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseanchor();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseinline_code();
	            if (s0 === peg$FAILED) {
	              s0 = peg$parseimg();
	              if (s0 === peg$FAILED) {
	                s0 = peg$parsea_img();
	                if (s0 === peg$FAILED) {
	                  s0 = peg$parsestrong();
	                  if (s0 === peg$FAILED) {
	                    s0 = peg$parseem();
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsestrong() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 2) === peg$c57) {
	        s1 = peg$c57;
	        peg$currPos += 2;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c58);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = [];
	        s3 = peg$currPos;
	        s4 = peg$currPos;
	        peg$silentFails++;
	        if (input.substr(peg$currPos, 2) === peg$c57) {
	          s5 = peg$c57;
	          peg$currPos += 2;
	        } else {
	          s5 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c58);
	          }
	        }
	        peg$silentFails--;
	        if (s5 === peg$FAILED) {
	          s4 = void 0;
	        } else {
	          peg$currPos = s4;
	          s4 = peg$FAILED;
	        }
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parsetext_single();
	          if (s5 !== peg$FAILED) {
	            s4 = [s4, s5];
	            s3 = s4;
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s3;
	          s3 = peg$FAILED;
	        }
	        if (s3 !== peg$FAILED) {
	          while (s3 !== peg$FAILED) {
	            s2.push(s3);
	            s3 = peg$currPos;
	            s4 = peg$currPos;
	            peg$silentFails++;
	            if (input.substr(peg$currPos, 2) === peg$c57) {
	              s5 = peg$c57;
	              peg$currPos += 2;
	            } else {
	              s5 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c58);
	              }
	            }
	            peg$silentFails--;
	            if (s5 === peg$FAILED) {
	              s4 = void 0;
	            } else {
	              peg$currPos = s4;
	              s4 = peg$FAILED;
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsetext_single();
	              if (s5 !== peg$FAILED) {
	                s4 = [s4, s5];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          }
	        } else {
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          if (input.substr(peg$currPos, 2) === peg$c57) {
	            s3 = peg$c57;
	            peg$currPos += 2;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c58);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c59(s2);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseem() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 42) {
	        s1 = peg$c60;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c61);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = [];
	        s3 = peg$currPos;
	        s4 = peg$currPos;
	        peg$silentFails++;
	        if (input.charCodeAt(peg$currPos) === 42) {
	          s5 = peg$c60;
	          peg$currPos++;
	        } else {
	          s5 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c61);
	          }
	        }
	        peg$silentFails--;
	        if (s5 === peg$FAILED) {
	          s4 = void 0;
	        } else {
	          peg$currPos = s4;
	          s4 = peg$FAILED;
	        }
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parsetext_single();
	          if (s5 !== peg$FAILED) {
	            s4 = [s4, s5];
	            s3 = s4;
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s3;
	          s3 = peg$FAILED;
	        }
	        if (s3 !== peg$FAILED) {
	          while (s3 !== peg$FAILED) {
	            s2.push(s3);
	            s3 = peg$currPos;
	            s4 = peg$currPos;
	            peg$silentFails++;
	            if (input.charCodeAt(peg$currPos) === 42) {
	              s5 = peg$c60;
	              peg$currPos++;
	            } else {
	              s5 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c61);
	              }
	            }
	            peg$silentFails--;
	            if (s5 === peg$FAILED) {
	              s4 = void 0;
	            } else {
	              peg$currPos = s4;
	              s4 = peg$FAILED;
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsetext_single();
	              if (s5 !== peg$FAILED) {
	                s4 = [s4, s5];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          }
	        } else {
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 42) {
	            s3 = peg$c60;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c61);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c62(s2);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseinline_code() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 96) {
	        s1 = peg$c63;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c64);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = [];
	        s3 = peg$currPos;
	        s4 = peg$currPos;
	        peg$silentFails++;
	        if (input.charCodeAt(peg$currPos) === 96) {
	          s5 = peg$c63;
	          peg$currPos++;
	        } else {
	          s5 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c64);
	          }
	        }
	        peg$silentFails--;
	        if (s5 === peg$FAILED) {
	          s4 = void 0;
	        } else {
	          peg$currPos = s4;
	          s4 = peg$FAILED;
	        }
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parsetext_single();
	          if (s5 !== peg$FAILED) {
	            s4 = [s4, s5];
	            s3 = s4;
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s3;
	          s3 = peg$FAILED;
	        }
	        if (s3 !== peg$FAILED) {
	          while (s3 !== peg$FAILED) {
	            s2.push(s3);
	            s3 = peg$currPos;
	            s4 = peg$currPos;
	            peg$silentFails++;
	            if (input.charCodeAt(peg$currPos) === 96) {
	              s5 = peg$c63;
	              peg$currPos++;
	            } else {
	              s5 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c64);
	              }
	            }
	            peg$silentFails--;
	            if (s5 === peg$FAILED) {
	              s4 = void 0;
	            } else {
	              peg$currPos = s4;
	              s4 = peg$FAILED;
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsetext_single();
	              if (s5 !== peg$FAILED) {
	                s4 = [s4, s5];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          }
	        } else {
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 96) {
	            s3 = peg$c63;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c64);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c65(s2);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseglobal_link_text() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$currPos;
	      peg$silentFails++;
	      if (input.charCodeAt(peg$currPos) === 93) {
	        s4 = peg$c66;
	        peg$currPos++;
	      } else {
	        s4 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c67);
	        }
	      }
	      peg$silentFails--;
	      if (s4 === peg$FAILED) {
	        s3 = void 0;
	      } else {
	        peg$currPos = s3;
	        s3 = peg$FAILED;
	      }
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsetext_single();
	        if (s4 !== peg$FAILED) {
	          s3 = [s3, s4];
	          s2 = s3;
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$currPos;
	          peg$silentFails++;
	          if (input.charCodeAt(peg$currPos) === 93) {
	            s4 = peg$c66;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c67);
	            }
	          }
	          peg$silentFails--;
	          if (s4 === peg$FAILED) {
	            s3 = void 0;
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsetext_single();
	            if (s4 !== peg$FAILED) {
	              s3 = [s3, s4];
	              s2 = s3;
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c22(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseanchor_with_name_options() {
	      var s0, s1, s2, s3;
	
	      if (input.substr(peg$currPos, 2) === peg$c68) {
	        s0 = peg$c68;
	        peg$currPos += 2;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c69);
	        }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 93) {
	          s1 = peg$c66;
	          peg$currPos++;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c67);
	          }
	        }
	        if (s1 !== peg$FAILED) {
	          s2 = peg$parse_();
	          if (s2 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 91) {
	              s3 = peg$c36;
	              peg$currPos++;
	            } else {
	              s3 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c37);
	              }
	            }
	            if (s3 !== peg$FAILED) {
	              s1 = [s1, s2, s3];
	              s0 = s1;
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseanchor_with_name() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 91) {
	        s1 = peg$c36;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c37);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseglobal_link_text();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseanchor_with_name_options();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parseglobal_link_text();
	            if (s4 !== peg$FAILED) {
	              if (input.charCodeAt(peg$currPos) === 93) {
	                s5 = peg$c66;
	                peg$currPos++;
	              } else {
	                s5 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                  peg$fail(peg$c67);
	                }
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c70(s2, s4);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseanchor() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 91) {
	        s1 = peg$c36;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c37);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseglobal_link_text();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 93) {
	            s3 = peg$c66;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c67);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c71(s2);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseurl() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      if (peg$c72.test(input.charAt(peg$currPos))) {
	        s2 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c73);
	        }
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          if (peg$c72.test(input.charAt(peg$currPos))) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c73);
	            }
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c22(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseglobal_link() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 91) {
	        s1 = peg$c36;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c37);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseglobal_link_text();
	        if (s2 !== peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c74) {
	            s3 = peg$c74;
	            peg$currPos += 4;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c75);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parseurl();
	            if (s4 !== peg$FAILED) {
	              if (input.charCodeAt(peg$currPos) === 62) {
	                s5 = peg$c76;
	                peg$currPos++;
	              } else {
	                s5 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                  peg$fail(peg$c77);
	                }
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c78(s2, s4);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseglobal_link_list() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parseglobal_link();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parseglobal_link();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c79(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c81.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c82);
	        }
	      }
	      while (s1 !== peg$FAILED) {
	        s0.push(s1);
	        if (peg$c81.test(input.charAt(peg$currPos))) {
	          s1 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c82);
	          }
	        }
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c80);
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsespace() {
	      var s0, s1;
	
	      s0 = [];
	      if (peg$c83.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c84);
	        }
	      }
	      while (s1 !== peg$FAILED) {
	        s0.push(s1);
	        if (peg$c83.test(input.charAt(peg$currPos))) {
	          s1 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c84);
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail(peg$endExpectation());
	      }
	
	      throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse: peg$parse
	  };
	}();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(19);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Index = __webpack_require__(15);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var base = 'GPKEDITOR - ';
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: [{ path: '/',
	    component: _Index2.default,
	    meta: { title: base + 'Index' }
	  }]
	});
	
	router.beforeEach(function (to, from, next) {
	  document.title = to.meta.title;
	  next();
	});
	
	exports.default = router;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(12)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(3),
	  /* template */
	  __webpack_require__(18),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(11)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(4),
	  /* template */
	  __webpack_require__(17),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(10)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(16),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "view",
	    attrs: {
	      "id": "index-view"
	    }
	  }, [_c('gpk-editor')], 1)
	},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "gpk-editor"
	    }
	  }, [_c('textarea', {
	    staticClass: "input",
	    domProps: {
	      "value": _vm.input
	    },
	    on: {
	      "input": _vm.update,
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
	        _vm.enter($event)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "preview",
	    domProps: {
	      "innerHTML": _vm._s(_vm.compiledMarkdown)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._m(0), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('router-view')], 1), _vm._m(1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://ohusmobs2.bkt.clouddn.com/20170616149758498873692.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer"
	  }, [_vm._v("©"), _c('a', {
	    attrs: {
	      "src": "https://github.com/ericjjj"
	    }
	  }, [_vm._v("Eric  ")]), _c('a', {
	    attrs: {
	      "src": "https://github.com/gpkeditor/gpkeditor"
	    }
	  }, [_vm._v("Github")]), _vm._v(" ")])
	}]}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.3a5b8cb6b074629db0d0.js